var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.showItem)?_c('v-list-item',{key:`top-navbar-${_vm.item.id}`,attrs:{"to":_vm.item.to},on:{"click":_vm.handleOnClick}},[_c('v-list-item-icon',[_c('v-icon',[_vm._v(_vm._s(_vm.item.icon))])],1),_c('v-list-item-content',[_c('v-list-item-title',{staticClass:"title-sm"},[_vm._v(_vm._s(_vm.item.name))])],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }